<template>
		<component
			:is="component"
			v-bind="props"
			v-bind:name="name"
			:error="error"
			:value="value"
			@input="handleComponentInput"
		/>
</template>
<script>
export default {
	props: {
		element: {
			type: Object,
			required: true
		},
		name: {
			type: String,
			required: true
		},
		value: {
			required: true
		},
		error: {
			type: Object,
			required: false,
			default: null
		}
	},
	computed: {
		component() {
			const componentName = this.element.component;
			return () => import (`./${componentName}`);
		},
		props() {
			return this.element;
		} 
	},
	methods: {
		handleComponentInput(value) {
			this.$emit('input', value)
		}
	}
	
}
</script>